import { isFlowTheme } from 'src/Libs/utils'
import { UserLevel } from 'src/State/User/UserModel'

export const ADMIN_ROLES = ['E3DC_ADMIN', 'E3DC_ROOT'] as UserLevel[]
export const SERVICE_LEVELS = ['E3DC_SERVICE', isFlowTheme ? 'EXT_SERVICE_PLUS' : undefined, ...ADMIN_ROLES] as UserLevel[]
export const SERVICE_LEVELS_ALL = ['EXT_SERVICE', 'EXT_SERVICE_PLUS', ...SERVICE_LEVELS] as UserLevel[]
export const INSTALLER_PARTNER = ['INSTALLER', 'PARTNER'] as UserLevel[]
export const SHOP_ACCESS = [...INSTALLER_PARTNER, ...SERVICE_LEVELS] as UserLevel[]
